angular.module('logbook')
.config(['$locationProvider', function ($locationProvider) {
   $locationProvider.hashPrefix('');
}]);